import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
export var ModalFooter = function (props) {
    var _a = props.componentClass, componentClass = _a === void 0 ? 'modal' : _a, className = props.className, children = props.children;
    var classes = cx(bcx(componentClass, 'footer d-flex justify-content-center'), className);
    return React.createElement("div", { className: classes }, children);
};
//# sourceMappingURL=ModalFooter.js.map